import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { getExpandedItems } from "../../utils/outbound-labels-utils";
import { StringListCell } from "../cells/string-list-cell";

const catalogEntry = fgColumnEntries["item-barcode"];

export const ItemBarcodeColumn: Column2<FulfillmentGroupData> = {
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }) => {
    const barcodes = new Set(
      row.items.flatMap((item) => (item.barcode ? [item.barcode] : [])),
    );
    return (
      <StringListCell displayName="barcode" strings={Array.from(barcodes)} />
    );
  },
  width: catalogEntry.defaultWidth,
  alignment: ColumnAlignment.LEFT,
  sort: catalogEntry.sortDirection,
  renderExpandedCell: ({
    row,
    expansionIndex,
  }: {
    row: FulfillmentGroupData;
    expansionIndex: number;
  }) => {
    return (
      <RedoTableTextCell
        text={getExpandedItems(row)?.[expansionIndex]?.barcode ?? ""}
      />
    );
  },
};
